export default __webpack_public_path__ + "static/media/check.9b3ab067.png";